<template>
  <div :class="style.buttonAdd">
    <button>
      <span :class="style.icon">+</span>
      <!--      <img :class="style.icon" :src="plusIconDefault" />-->
      <span v-text="text" />
    </button>
  </div>
</template>
<script lang="ts">
import plusIconDefault from "$images/plus icon default.svg";
import {defineComponent} from "vue";
import style from "./ButtonAdd.module.scss";
export default defineComponent({
  props: ["text"],
  data() {
    return {
      style,
      plusIconDefault
    };
  }
});
</script>
